import DepsService from 'services/dependencies';

const CONTEXT = undefined;

export const fetchRedirectDetails = (type, adminId, alertId) => {
  const { url } = DepsService.rest.lsp.redirect;
  const queryParams = { type, adminId, alertId };
  const urlParams = {};

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/lsp/lsp.api.js